module.exports = __webpack_public_path__ + "static/media/error-img.0164b402.png";